import { SelectOption } from '@/features/editMode/types/selectOption';
import { CreateInsuredState } from '../types/createInsuredTypes';
import { AddInsuredModalSteps } from '@/features/serviceModal/components/AddInsuredModal/enums';
import { CreateEntityTypesEnum } from '@/enums/CreateEntityTypesEnum';

const initialCreateInsuredSteps = {
  [AddInsuredModalSteps.InsuredDetails]: {
    firstName: '',
    middleName: '',
    lastName: '',
    suffix: '',
    genderId: null,
    ssn: '',
    dateOfBirth: null,
    dateOfDeath: null,
    documentsDeliveryPreferenceId: null,
    maritalStatusId: null,
    occupationId: null,
    prefix: '',
    isSsnValid: true,
    ssnValidationResult: null,
    clientId: '',
  },
  [AddInsuredModalSteps.AddressDetails]: {
    isPaymentAddress: false,
    isResidenceAddress: false,
    isMailingAddress: false,
    reAttn: '',
    streetAddress: '',
    addressDetails: '',
    city: '',
    state: '',
    zipCode: '',
    country: '',
  },
  [AddInsuredModalSteps.ContactInformation]: {
    contactPreference: '',
    contactPreferenceId: null,
    mobileNumber: '',
    landline: '',
    email: '',
    fax: '',
  },
  [AddInsuredModalSteps.PaymentInformation]: [],
};

export const createInsuredInitialState: CreateInsuredState = {
  createInsuredType: CreateEntityTypesEnum.AUTO,
  createInsuredSteps: initialCreateInsuredSteps,
  selectOptions: {
    occupations: [] as SelectOption[],
    martialStatuses: [] as SelectOption[],
    documentPreferences: [] as SelectOption[],
    genders: [] as SelectOption[],
    contactPreferences: [] as SelectOption[],
    prefixes: [] as SelectOption[],
  },
  existingCreateInsuredUserData: null,
  userForInsuredCreate: null,
  usersListForInsuredCreate: null,
  statuses: {
    isSelectOptionsLoading: false,
    isCreateInsuredLoading: false,
  },
};
